import { render, staticRenderFns } from "./counter.vue?vue&type=template&id=36e136b2&scoped=true&"
import script from "./counter.vue?vue&type=script&lang=js&"
export * from "./counter.vue?vue&type=script&lang=js&"
import style0 from "./counter.vue?vue&type=style&index=0&id=36e136b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e136b2",
  null
  
)

component.options.__file = "counter.vue"
export default component.exports